export const REF_GOOD_MHIK_TAB = 'REF_GOOD_MHIK_TAB';
